export default __webpack_public_path__ + "static/media/simplehabit-analysis.4eb1e40b.png";